import React from 'react';
import PrimaryButton from './../../../../../Shared/Components/PrimaryButton/PrimaryButton';

const Upload = props => {
    return (
        <div className="row">
            <div className="col-12">
                <div className="form">
                    <div className="form-group">
                        <label>Title</label>
                        <input className="form-control" name="title" id="title" value={props.state?.title ?? ''} onChange={props.handleChange} />
                        <small className="errorMessage">{props.errors.title}</small>
                    </div>
                    <div className="form-group">
                        <label>Friendly Name</label>
                        <input className="form-control" name="friendlyName" id="friendlyName" value={props.state?.friendlyName ?? ''} onChange={props.handleChange} />
                    </div>
                    <div className="form-group">
                        <label>Description</label>
                        <textarea style={{ "minHeight": "150px" }} className="form-control" name="description" id="description" value={props.state?.description ?? ''} onChange={props.handleChange} />
                        <small className="errorMessage">{props.errors.description}</small>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-6">
                            <label>Reference</label>
                            <input className="form-control" name="reference" id="reference" value={props.state?.reference ?? ''} onChange={props.handleChange} />
                            <small className="errorMessage">{props.errors.reference}</small>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="d-flex align-items-center" style={{ gap: '10px', cursor: 'pointer' }}>
                            <input
                                type="checkbox"
                                name="hasAssessment"
                                checked={!!props.state?.hasAssessment}
                                onChange={props.handleChange}
                            />
                            This course includes assessments
                        </label>
                    </div>
                    <PrimaryButton text="Create" func={props.handleSubmit} classes="float-right mt-3" />
                </div>
            </div>
        </div>
    );
};

export default Upload;